import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_RESERVE_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { getMyReservesSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/remove_res`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveReserve(args) {
    const user = yield select(state => state.user);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);

        formData.append('reserve_id', args.data.reserve_id);

        const response = yield call (request, formData);

        if (response.success) {
            toast.success(response.message);
            // Обновляем список записей на услуги
            yield put(getMyReservesSagaAction());
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherRemoveReserve() {
    yield takeLatest(REMOVE_RESERVE_SAGA, workerRemoveReserve);
}